"use client";

import { GlobalConsumer } from "@/data/store";
import { AuthModal } from "../blocks/AuthModal";

export function AuthModalContainer() {
  return (
    <GlobalConsumer getters={["isAuthModalOpened"]} mutations={["login"]}>
      {({ isAuthModalOpened, setIsAuthModalOpened, login }) => (
        <AuthModal
          error={login.error ? (login.error as Error).message : undefined}
          isOpened={isAuthModalOpened}
          onClose={() => setIsAuthModalOpened(false)}
          onSignIn={(credentials) => {
            login({ type: "credentials", credentials });
          }}
          onSignUp={(credentials) => {
            login({ type: "signup", credentials });
          }}
          onGoogleSignIn={() => {
            login({ type: "google" });
          }}
          onChange={() => {}}
          isLoading={login.status === "loading"}
        />
      )}
    </GlobalConsumer>
  );
}
